(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-details"] && !Shopify.designMode) return;
  try {
    (function () {
    const popup = document.getElementById('size-guide-popup');
    if (!popup) return;

    const openBtn = document.querySelector('[data-open="size-guide-popup"]');
    const closeBtn = popup.querySelector('.size-guide-close');

    const open = () => popup.classList.add('is-open');
    const close = () => popup.classList.remove('is-open');

    if (openBtn) openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    popup.addEventListener('click', (e) => {
      if (e.target === popup) close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
